import LanguageMenu from './language-menu.vue';

export default LanguageMenu;
